import apiCalls from "../Configs/config";

const queryString = require("query-string");
const fdAuthProvider = {
  // called when the user attempts to log in
  // login: ({ username, password }: { username: string; password: string }) => {
  //   const query = {password};
  //   const request = new Request(
  //     `${
  //       apiCalls.apiUrl
  //     }/authentication/login/${username}?${queryString.stringify(query)}`,
  //     { method: "GET" }
  //   );
  //   return fetch(request)
  //     .then((response) => {
  //       if (response.status < 200 || response.status >= 300) {
  //         throw new Error(response.statusText);
  //       }
  //       return response.json();
  //     })
  //     .then((loginInfo) => {
  //       localStorage.setItem("fielddrive-token", loginInfo.token);
  //       localStorage.setItem("fielddrive-session", JSON.stringify(loginInfo));
  //     });
  // },
  login: (loginInfo: any) => {
    localStorage.setItem("fielddrive-token", loginInfo.token);
    localStorage.setItem("fielddrive-session", JSON.stringify(loginInfo));
    sessionStorage.removeItem("fd-portal-v2-modal-shown");
    return Promise.resolve();
  },

  // called when the user clicks on the logout button
  logout: () => {
    // const request = new Request(`${apiCalls.apiUrl}/authentication/logout?token=${localStorage.getItem('fielddrive-token')}`,
    // {
    //   method: "GET"
    // })
    // return fetch(request)
    // .then((response) => {
    //   if (response.status < 200 || response.status >= 300) {
    //     throw new Error(response.statusText);
    //   }
    //   const session = localStorage.getItem("fielddrive-session") as string;
    //   document.cookie = `${JSON.parse(session).userId}fielddrive-event-selected=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    //   document.cookie = "fielddrive-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    //   document.cookie = "fielddrive-session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    //   document.cookie = "fielddrive-lastpage=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    //   localStorage.removeItem("fielddrive-token");
    //   localStorage.removeItem("fielddrive-session");
    //   return Promise.resolve();

    // })
    localStorage.removeItem("fielddrive-token");
    localStorage.removeItem("fielddrive-session");
    return Promise.resolve();
  },
  // called when the API returns an error
  checkError: (errorObject: { status: any }) => {
    const { status = null } = errorObject || {};
    if (status && (status === 401 || status === 403)) {
      localStorage.removeItem("fielddrive-token");
      localStorage.removeItem("fielddrive-session");
      return Promise.reject();
    }
    return Promise.resolve();
  },
  // called when the user navigates to a new location, to check for authentication
  checkAuth: () => {
    return localStorage.getItem("fielddrive-token")
      ? Promise.resolve()
      : Promise.reject();
  },
  // called when the user navigates to a new location, to check for permissions / roles
  getPermissions: () => {
    if (localStorage.getItem("fielddrive-session")) {
      const roles = JSON.parse(
        localStorage.getItem("fielddrive-session") as string
      ).roles;
      return roles ? Promise.resolve(roles) : Promise.reject();
    } else {
      return Promise.reject();
    }
  },
  getIdentity: () => {
    try {
      const session = localStorage.getItem("fielddrive-session");
      if (session) {
        const userId = JSON.parse(session).userId as string;
        return Promise.resolve({ id: parseInt(userId, 10) });
      } else {
        return Promise.resolve({ id: 0 });
      }
    } catch (error: any) {
      return Promise.reject(error);
    }
  },

  resetPassword: ({ email }: { email: string }) => {
    const hostnameParts = window.location.hostname.split(".");
    const subdomain = hostnameParts
      .slice(0, hostnameParts.length - 2)
      .join(".");
    const request = new Request(
      `${apiCalls.apiUrl}/authentication/resetPassword?userData=${email}&subdomain=${subdomain}`,
      {
        method: "POST",
      }
    );
    return fetch(request).then((response) => {
      if (response.status < 200 || response.status >= 300) {
        throw new Error(response.statusText);
      }
      return response;
    });
  },

  changePassword: ({
    password,
    token,
  }: {
    password: string;
    token: string;
  }) => {
    const query = {
      password,
      token,
    };

    const request = new Request(
      `${apiCalls.apiUrl}/authentication/changePassword?${queryString.stringify(
        query
      )}`,
      {
        method: "POST",
      }
    );

    return fetch(request).then((response) => {
      if (response.status < 200 || response.status >= 300) {
        throw new Error(response.statusText);
      }
      return response;
    });
  },
};

export default fdAuthProvider;
